import React from 'react'

import Empty from 'app/components/common/Empty'
import { reportTypes } from 'app/common/api/requests/reports/perform'
import { Space } from 'app/common/templates-next/report-template'

import DetailedReport from './Detailed/Report'
import DetailedReportFilter from './Detailed/ReportFilter'

import { GroupedSubsidies } from './Grouped/GroupedResult'
import { ActSubsidies } from './Act/ActResult'

type Props = {
  subReport: string
}

const DetailedSubsidies = () => (
  <>
    <DetailedReportFilter />
    <Space />
    <DetailedReport />
  </>
)
const GroupedSubsidiesReport = () => (
  <>
    <GroupedSubsidies />
  </>
)

const ActSubsidiesReport = () => (
  <>
    <ActSubsidies />
  </>
)

const subReportLayouts: Partial<Record<string, React.ComponentType>> = {
  [reportTypes.REPORT_SUBSIDIES_DETAILED]: DetailedSubsidies,
  [reportTypes.REPORT_SUBSIDIES_GROUPED]: GroupedSubsidiesReport,
  [reportTypes.REPORT_SUBSIDIES_ACT]: ActSubsidiesReport,
}

const Subsidies = ({ subReport }: Props) => {
  const SubReportLayout = subReportLayouts[subReport]

  return SubReportLayout ?
    <SubReportLayout />
    : <Empty />
}

export default Subsidies
